import React from 'react';
import { useInView } from 'react-intersection-observer';

const Universe: React.FC = () => {
  const { ref: leftRef, inView: leftInView } = useInView({ threshold: 0.12, triggerOnce: true });
  const { ref: rightRef, inView: rightInView } = useInView({ threshold: 0.12, triggerOnce: true });

  return (
    <section id="univers" className="section-dark">
      <div className="section-inner">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-24">
          <div className={`reveal ${leftInView ? 'visible' : ''}`} ref={leftRef}>
            <span className="section-tag">— Notre Univers —</span>
            <h2 className="section-title">L'ADN de GERAK</h2>
            
            <p className="text-silver text-sm leading-relaxed mb-7">
              GERAK n'est pas simplement une marque de vêtements. C'est une vision de la masculinité contemporaine — exigeante, raffinée, authentique.
            </p>
            
            <p className="text-silver text-sm leading-relaxed mb-7">
              Fondée avec la conviction que l'homme moderne mérite des vêtements à la hauteur de ses ambitions, GERAK associe des matières soigneusement sélectionnées à des coupes maîtrisées qui traversent les saisons.
            </p>
            
            <p className="text-silver text-sm leading-relaxed mb-7">
              Chaque collection est pensée comme une déclaration — non pas au monde, mais à soi-même. Un rappel silencieux de qui l'on est, et de qui l'on veut devenir.
            </p>

            <div className="flex border-t border-mid pt-9 mt-12">
              {[
                { num: '8+', label: 'Collections' },
                { num: '100%', label: 'Masculin' },
                { num: '∞', label: 'Style' },
              ].map((stat, index) => (
                <React.Fragment key={stat.label}>
                  <div className="flex-1">
                    <span className="font-serif text-4xl font-bold text-white">
                      {stat.num}
                    </span>
                    <span className="block text-[9px] tracking-[3px] uppercase text-silver mt-1">
                      {stat.label}
                    </span>
                  </div>
                  {index < 2 && <div className="w-px bg-mid mx-8"></div>}
                </React.Fragment>
              ))}
            </div>
          </div>

          <div className={`flex flex-col gap-0.5 reveal ${rightInView ? 'visible' : ''}`} ref={rightRef}>
            {[
              {
                num: '01',
                title: 'Précision',
                desc: 'Chaque couture, chaque tissu est choisi avec une exigence absolue. Rien n\'est laissé au hasard dans la construction d\'une pièce GERAK.',
              },
              {
                num: '02',
                title: 'Identité',
                desc: 'GERAK forge un style reconnaissable, distinctif, authentiquement masculin. Porter GERAK, c\'est affirmer clairement qui l\'on est.',
              },
              {
                num: '03',
                title: 'Durabilité',
                desc: 'Des pièces pensées pour durer, traverser les saisons et les tendances. L\'anti-fast-fashion par excellence.',
              },
              {
                num: '04',
                title: 'Accessibilité',
                desc: 'Le luxe de s\'habiller bien, sans compromis sur la qualité ni sur l\'accessibilité. GERAK pour chaque homme ambitieux.',
              },
            ].map(value => (
              <div
                key={value.num}
                className="bg-dark p-7 border border-mid flex gap-6 hover:border-silverLight transition-colors"
              >
                <span className="font-serif text-3xl text-mid leading-none font-bold min-w-[34px]">
                  {value.num}
                </span>
                <div>
                  <h4 className="text-[11px] tracking-[2.5px] uppercase text-white font-semibold mb-2">
                    {value.title}
                  </h4>
                  <p className="text-sm text-silver leading-relaxed">
                    {value.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Universe;